var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: {
            inline: true,
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "80px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "公证事项", prop: "notaryItem" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    disabled: true,
                    clearable: "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.ruleForm.notaryItem,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "notaryItem", $$v)
                    },
                    expression: "ruleForm.notaryItem"
                  }
                },
                _vm._l(_vm.gzItems, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "公证费用", prop: "charge" } },
            [
              _c(
                "el-input",
                {
                  attrs: {
                    size: "small",
                    disabled: true,
                    placeholder: "请输入"
                  },
                  model: {
                    value: _vm.ruleForm.charge,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "charge", $$v)
                    },
                    expression: "ruleForm.charge"
                  }
                },
                [_c("template", { slot: "append" }, [_vm._v("元")])],
                2
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "公证员", prop: "notaryId" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    disabled: _vm.status !== 1 || _vm.openType == "see",
                    clearable: "",
                    placeholder: "请选择"
                  },
                  model: {
                    value: _vm.ruleForm.notaryId,
                    callback: function($$v) {
                      _vm.$set(_vm.ruleForm, "notaryId", $$v)
                    },
                    expression: "ruleForm.notaryId"
                  }
                },
                _vm._l(_vm.notarys, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.openType === "edit" && _vm.status !== 6
            ? _c(
                "el-form-item",
                { attrs: { label: "指派给", prop: "owner" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        size: "small",
                        clearable: "",
                        placeholder: "请选择"
                      },
                      model: {
                        value: _vm.ruleForm.owner,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "owner", $$v)
                        },
                        expression: "ruleForm.owner"
                      }
                    },
                    _vm._l(_vm.notarys, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }